let $ = require("jquery");
import _ from "underscore";
import render from '../../utilities/render';
import { isTruthy, isFalsey, isBlank } from '../../utilities/general'
import { setElementsFromScope, setOptionsForSelect } from '../../utilities/selectorHelpers';
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";


const productTemplate = require("./html/returnRequestsProduct.html");
const warehouseProductTemplate = require("./html/addRmaProducts.html");
const reviewProductTemplate = require("./html/returnRequestsReviewProduct.html");
const reviewWarehouseProductTemplate = require("./html/returnRequestsWarehouseReviewProduct.html");
const productAttrTemplate = require("./html/returnRequestsProductAttr.html");
const modalHtml = require("../../sharedHtml/modal.html");
const duplicateSkuTemplate = require("./html/returnRequestsDuplicateSkuModal.html");

let    unauthPrintHeader = false;

const elementsPageMap = {
  addProductBtn: '#find-rma-item',
  addWarehouseProductBtn: '#warehouse-find-rma-item',
  itmSku: '.itmSku',
  warehouseitmSku: '.warehouseitmSku',
  itmUpc: '.itmUpc',
  warehouseitmUpc: '.warehouseitmUpc',
  itmDescription: '.itmDescription',
  warehouseitmDescription: '.warehouseitmDescription',
  itmBrand: '.itmBrand',
  itmModel: '.itmModel',
  warehouseitmModel: '.warehouseitmModel',
  warehouseRTV: '#warehouseRTV',
  warehouseRmaNoItemFound: '#warehouse-rma-no-item-found',
  warehouseRmaNoItemAdded: '#warehouse-rma-no-item-added',
  rmaLevel: '#rma-level',

  revRmaProdSku: '.rev-rma-prod-sku',
  revRmaUpc: '.rev-rma-upc',
  revRmaDesc: '.rev-rma-prod-descrip',
  revRmaQty: '.rev-rma-qty',
  revRmaReason: '.rev-rma-reason',
  revRmaColor: '.rev-rma-color',
  revRmaBrand: '.rev-rma-brand',
  revRmaSize: '.rev-rma-size',
  revRmaModel: '.rev-rma-model',
  revRmaStyle: '.rev-rma-style',
  addRmaItmAttrName: ".add-rma-itm-attr-name",
  addRmaItmAttrValue: ".add-rma-itm-attr-value",

  itmSkuHidden: '.itmSkuHidden',
  itmSelectBlock: ".product-select-block",
  itemSkuAlreadyAdded: '#item-sku-already-added',
  warehouseItemSkuAlreadyAdded: '#warehouse-item-sku-already-added',
  addRmaProductQuantity: ".add-rma-product-quantity",
  addRmaProductNo: ".add-rma-order-number",
  addRmaReturnQuantity: '#add-rma-return-quantity',
  addRmaReturnQuantityError: '#add-rma-return-quantity-error',
  addRmaReason: ".add-rma-reason",
  addRmaReasonDiv: ".add-rma-reason-div",
  addRmaProductWeignt: ".add-rma-product-weight",
  addRmaProductWeigntDiv: ".add-rma-product-weight-div",
  addRmaNotes: ".add-rma-notes",
  addRmaNotesDiv: ".add-rma-notes-div",
  addRmaOrderNumber: ".add-rma-order-number",
  addRmaItmAttr: ".add-rma-itm-attr",
  reviewRmaItmAttr: ".review-rma-itm-attr",
  reviewRmaNotes: ".review-rma-notes",
  itemMarkedAsNonReturnableMsg: ".item-marked-as-non-returnable-msg",

  itmSkuOrUpc: "#find-rma-by-sku-and-upc",
  warehouseItmSkuUPCModal: "#warehouse-find-itm-by-sku-upc-and-modal",
  returnFromState: "#rma-state",
  rmaMultiItemsWarning: "#rma-multi-items-warning",


  addRmaReturnsShipToAddress: '.add-rma-returns-ship-to-address',
  ifReturnToShipAddressSet: '.if-return-to-ship-address-set',
  addRmaReturnsShippingService: '.add-rma-returns-shipping-service',
  ifReturnsShipServiceSet: '.if-returns-ship-service-set',
  returnsShipServiceMessage: '.returns-ship-service-message',
  sapConfigMessageSet: '.sap-no-config-set-msg',
  sapCasSectionMessage: '.sap-cas-section',
  sapSplCreditMessage: '.sap-spl-cred-section',
  sapRetLabelMessage: '.sap-ret-label-disp-section',
  sapRetShipMessage: '.sap-ret-ship-overrides-section',
  sapDecalredMessage: '.sap-dec-val-section',

  addRmaSpecialCreditProcess: '.add-rma-special-credit-process',
  specialEarlyCreditMsg: '.special-early-credit-msg',
  specialNonCreditMsg: '.special-non-credit-msg',
  specialGiftCreditMsg: '.special-gift-msg',

  addRmaSearchItemDiv: '.add-rma-search-item-div',
  addWarehouseRmaSearchItemDiv: '.add-warehouse-rma-search-item-div',
  addRmaProductFinalSale: ".add-rma-product-final-sale",
  addRmaProductFinalSaleDiv: ".add-rma-product-final-sale-div",

  originalOrderNumberDiv: '.original-order-number',

  originalOrderNumberLabelRequired: '.original-order-number-required',
  originalOrderNumberLabelNotRequired: '.original-order-number-not-required',
  addRmaParent: '#add-rma',

  //9043 Fields changes
  declaredValue: '.add-rma-declared-value',
  declaredErrorMsg: '.declared-value-error-msg',
  rmaCustomerIdTypeAhead: "#find-rma-by-address-or-location",

  warehouseCountry: "#warehouse-country",
  warehouseUsaStateDiv: "#warehouse-usa-state-div",
  warehouseCanadaProvinceDiv: "#warehouse-canada-province-div",
  warehouseStateTextDiv: "#warehouse-state-text-div",

  revWhsRmaProdSku: '.rev-whs-rma-prod-sku',
  revWhsRmaUpc: '.rev-whs-rma-upc',
  revWhsRmaDesc: '.rev-whs-rma-modal',
  revWhsRmaQty: '.rev-whs-rma-qty',
  revWhsRmaRtv: '.rev-whs-rma-rtv',
  prepaidCollectBtnGrp: '.prepaid-or-collect-btn-toggler'
};

export default function ReturnRequestsWizardLogic(mainEl) {
  const self = this;
  const elsPage = {};
  const elsModals = {};
  var rmaItemCount = 0;
  const oonVisible = mainEl.data("original-order-number-visible");
  const oonMandatory = mainEl.data("original-order-number-mandatory");
  const defaultItemConfig = mainEl.data("default-item-config-for-all-returns");
  const defaultItem = mainEl.data("default-item-for-all-returns");
  const captureReturnReason = mainEl.data("capture-return-reason");
  const captureWeight = mainEl.data("capture-weight");
  const captureFinalSale = mainEl.data("capture-final-sale");
  const captureProductNotes = mainEl.data("capture-product-notes");
  const capturesapAllConfigvisible = mainEl.data("capture-sapall-config-visible");
  const captureReturnLabelsVisible = mainEl.data("return-label-display-config-visible");
  const captureReturnShippingOverrideDisplay = mainEl.data("return-shipping-overrides-config-visible");
  const captureCreditProcessingValue = mainEl.data("return-credit-processing-value");
  const warehouseLevelRmas = mainEl.data("warehouse-level-rmas");
  
  const rmaData = mainEl.data("rma-data-json");
  const rmaId = rmaData.rmaId;
  const isHoneyComb = mainEl.data('is-honeycomb');
  let duplicateSkuModal;
  let itemSkuGlobal;

  self.init = function () {
    setElements();
    setInitialState();
    bindElements();
    hideInitial();
    renderDuplicateSkuModal();

    const prepaidCollectBtnGrp = elsPage.prepaidCollectBtnGrp;
    const prepaidCollectBtnToggler = new QuickBtnGroup(prepaidCollectBtnGrp, {
        distributeWidth: true
    });
    prepaidCollectBtnToggler.init();

    $(".add-rma-product-quantity").change(function () {
      fillDynamicContentToWizard();
    });

    // edit functionality starts here
    if(rmaData.rmaId != null && rmaData.rmaId != "") {
      let rmaItems = rmaData.rmaItemDetails;
      let rmaItemDetailUnAuthList = rmaData.rmaItemDetailUnAuthList;

      // Customer ID
      $("#find-rma-by-address-or-location").append(`<option value="${rmaData.rmaWarehouseCustomerID}">${rmaData.rmaWarehouseCustomerID}</option>`);
      $("#find-rma-by-address-or-location").val(rmaData.rmaWarehouseCustomerID).trigger("change");
      // Shipping Required
      if(rmaData.rmaShippingRequired) {
        $('.rmaShippingYes').attr('checked', 'checked');
      } else{
        $('.rmaShippingNo').attr('checked', 'checked');
      }
      // Prepaid or Collect
      prepaidCollectBtnToggler.activateBtnViaKey(rmaData.rmaWarehousePrepaidCollect);

      // Returning Products
      // Unauth Item
      if (rmaItemDetailUnAuthList){
        for(let i = 0; i < rmaItemDetailUnAuthList.length; i++) {
          if (i==0){
            unauthPrintHeader = true;
          }
          elsPage.addWarehouseRmaSearchItemDiv.append(buildWarehouseProductEdit(rmaData, rmaItemDetailUnAuthList[i], i));
          fillDynamicContentToWizard();
          unauthPrintHeader = false;
        }
      }

      //Auth Items
      if (rmaItems){
      for(let i = 0; i < rmaItems.length; i++) {
        elsPage.addWarehouseRmaSearchItemDiv.append(buildWarehouseProductEdit(rmaData, rmaItems[i], i));
        fillDynamicContentToWizard();
      }
      }


      // Processing & Shipping tab
      $("#return-ship-to-address").val(rmaData.rmaShipments[0].returnAddress.cadId).trigger("change");

      // Review tab
      //$("#find-rma-by-address-or-location").val(rmaData.rmaWarehouseCustomerID);
    }
  };

  function buildWarehouseProductEdit(rmaData, rmaItems, rmaItemCount) {

  rmaItemCount = $(".warehouse-item-returning-loop-wrapper").length;

    let formObjName = "rmaItemDetails";
    let formIndexElement = formObjName+"["+rmaItemCount+"]";
    let warehouseProductEl =  render(warehouseProductTemplate, {
        formIndexEle: formIndexElement,
        sku: rmaItems.itemSku,
        upc: rmaItems.itemUpc,
        model: rmaItems.itmModel,
        skuHidden: rmaItems.itemSku,
        itemExpectedQty: rmaItems.itemExpectedQty,
        rtvNum: rmaItems.rmaItemRtvNumber,
        rmdId: rmaItems.rmdId,
        rmdAmlStatus: rmaItems.rmdAmlStatus,
        rmaFromCountry: rmaData.rmaFromCountry,
        rmaItemCount: rmaItemCount,
        unauthPrintHeader:  unauthPrintHeader,
        showOrHide: "show"
    });
    return warehouseProductEl;
  }

  function setInitialState() {
    instantiateRmaCustomerIdTypeAhead();
    const rmaCustomerIdLookup = elsPage.rmaCustomerIdTypeAhead;
    rmaCustomerIdLookup.on("select2:select", function () {
      let res = rmaCustomerIdLookup.select2('data')[0].text;
      let shipToAddressId = rmaCustomerIdLookup.select2('data')[0].shipAddressId;
      $("#return-ship-to-address").val(shipToAddressId).trigger("change");
    });
  };


  function instantiateRmaCustomerIdTypeAhead() {
    const select2AjaxDefaults = {
      dataType: 'json',
      delay: 250,
      async: false,
      processResults: function (data, params) {
        params.page = params.page || 1;
        return {
          results: data,
          pagination: {
            more: (params.page * 20) < data.total_count
          }
        };
      },
      cache: true

    };

    function configureDataCallback({ paramKey }) {
      return function (params) {
        return {
          [paramKey]: params.term
        };
      };
    }

    elsPage.rmaCustomerIdTypeAhead.select2({
      placeholder: "Select Customer ID",
      allowClear: true,
      ajax: {
        ...select2AjaxDefaults,
        url: elsPage.rmaCustomerIdTypeAhead.data('get-rma-customer-id-list'),
        data: configureDataCallback({ paramKey: 'cmrAddressByAddressIdOrLocation' }),
        templateResult: function (result) {
          return result.text;
        }
      },
      minimumInputLength: 3
    });
  }

  function hideInitial() {
    elsPage.rmaMultiItemsWarning.hide();
    elsPage.itemMarkedAsNonReturnableMsg.hide();
    hideAllCreditInfo();
  }

  function setElements() {
    setElementsFromScope(elsPage, elementsPageMap, mainEl);
  }

  function bindElements() {
    const rmaSelectedLevel = elsPage.rmaLevel.val();
    if (rmaSelectedLevel == 'warehouse' || rmaSelectedLevel == 'customer') {
      elsPage.addWarehouseProductBtn.click((e) => {
        verifyWarehouse(elsPage.warehouseItmSkuUPCModal.val())
      });
    }
    else {
      elsPage.addProductBtn.click((e) => {
        verify(elsPage.itmSkuOrUpc.val())
      });
    }

    elsPage.addRmaReturnQuantity.on('keyup', function(e){
      if($(this).val() >1 ){
        elsPage.addRmaReturnQuantityError.hide();
      }
    });

    $(document).on("click", ".rma-item-remove", fillDynamicContentToWizard);
    elsPage.addRmaSearchItemDiv.on("change", fillDynamicContentToWizard);
    $(document).on("click", ".warehouse-rma-item-remove", fillDynamicContentToWizard);
    elsPage.addWarehouseRmaSearchItemDiv.on("change", fillDynamicContentToWizard);

    elsPage.addRmaReturnsShipToAddress.on("change", function () {
      if (isBlank(elsPage.addRmaReturnsShipToAddress.val()) || elsPage.addRmaReturnsShipToAddress.val() == '0') {
        elsPage.ifReturnToShipAddressSet.hide();
      } else {
        elsPage.ifReturnToShipAddressSet.show();
      }

    });
    elsPage.addRmaReturnsShippingService.on("change", function () {
      if (elsPage.addRmaReturnsShippingService.val() == '') {
        elsPage.ifReturnsShipServiceSet.hide();
      } else {
        if (elsPage.addRmaReturnsShippingService.val() == 'SP') {
          elsPage.returnsShipServiceMessage.html("All products in this return will be shipped with this shipping service unless an event occurs where SmartPost is unavailable. In that case, the return will be defaulted to ship Ground.")
        } else {
          elsPage.returnsShipServiceMessage.html("All products in this return will be shipped with this shipping service.")

        }
        elsPage.ifReturnsShipServiceSet.show();
      }
    });
    elsPage.addRmaSpecialCreditProcess.on("change", handleCreditChange);

    //9043 Declared Value Validation
       elsPage.declaredErrorMsg.hide();
    elsPage.declaredValue.on("change", function () {
      const declaredVal = parseFloat(elsPage.declaredValue.val()).toFixed(2);
      elsPage.declaredValue.val(declaredVal);
      elsPage.declaredErrorMsg.hide();
      if(isHoneyComb=='HONEYCOMB_RMS'){
        if(elsPage.addRmaReturnsShippingService.val() == 'SP' && elsPage.declaredValue.val() > 999){
             elsPage.declaredErrorMsg.show();
           }else{
             elsPage.declaredErrorMsg.hide();
           }
         }
         else{
      if (elsPage.addRmaReturnsShippingService.val() == 'SP' && elsPage.declaredValue.val() > 100) {
        elsPage.declaredErrorMsg.show();
      } else {
        elsPage.declaredErrorMsg.hide();
      }
    }
    });
    if (capturesapAllConfigvisible) {
      elsPage.sapConfigMessageSet.show();
      elsPage.sapCasSectionMessage.hide();
      elsPage.sapSplCreditMessage.hide();
      elsPage.sapRetLabelMessage.hide();
      elsPage.sapRetShipMessage.hide();
      elsPage.sapDecalredMessage.hide();
    }
    else {
      elsPage.sapConfigMessageSet.hide();
    }

    if (captureReturnLabelsVisible) {
      elsPage.sapRetLabelMessage.hide();
    }

    if (captureReturnShippingOverrideDisplay) {
      elsPage.sapRetShipMessage.hide();
    }


    if (defaultItemConfig) {
      elsPage.itmSkuOrUpc.removeAttr("multiple");
      elsPage.itmSkuOrUpc.removeClass("quick-toggler");
      elsPage.itmSkuOrUpc.addClass("select2-select");
      setOptionsForSelect({
        selectElement: elsPage.itmSkuOrUpc,
        list: defaultItem,
        valueDataKey: "itmSku",
        textDataKey: "itmSku",
        initialSelectValue: () => {
          return defaultItem[0].itmSku;
        }
      });

    } else {
      elsPage.itmSkuOrUpc.select2({
        ajax: {
          ...select2AjaxDefaults,

          url: $("#find-rma-by-sku-and-upc").data('url'),
          data: configureDataCallback({ paramKey: 'itmSkuOrUpc' }),
          templateResult: function (result) {
            return result.text;
          }
        },
        minimumInputLength: 3
      });

      elsPage.itmSkuOrUpc.on("select2:select", function (e) {
        verify(this.value);
        elsPage.itmSkuOrUpc.val(null).trigger('change');
      });
    }


    //HB-11513 Start Initiated the Warehouse Select2 no default item config required for us
    elsPage.warehouseItmSkuUPCModal.select2({
      ajax: {
        ...select2AjaxDefaults,

        url: $("#warehouse-find-itm-by-sku-upc-and-modal").data('url'),
        data: configureDataCallback({ paramKey: 'itmSkuOrUpc' }),
        templateResult: function (result) {
          return result.text;
        }
      },
      minimumInputLength: 3
    });

    elsPage.warehouseItmSkuUPCModal.on("select2:select", function (e) {
      verifyWarehouse(this.value);
      elsPage.warehouseItmSkuUPCModal.val(null).trigger('change');
    });
    //HB-11513 end
    // Click event from duplicate sku modal
    $(document).on("click", '.duplicate-sku-close-modal', hideDuplicateSkuModal);
    $(document).on("click", '.duplicate-sku-add-button', addDuplicateSkuFromModal);

    const shipToAddress = $("#return-ship-to-address");
    let shipToAddressOptions = shipToAddress.find('option').each(function(el) {
      return el;
    });
    const canadaOptions = _.filter(shipToAddressOptions, function(v){
      return v.innerText.match(/CA/g);
    });
    const usOptions = _.filter(shipToAddressOptions, function(v){
      return v.innerText.match(/US/g);
    });

    elsPage.warehouseCountry.on("change", warehouseCountryOnChange);

    function warehouseCountryOnChange(e) {
        if (elsPage.warehouseCountry.val() === 'US') {
          elsPage.warehouseUsaStateDiv.show();
          elsPage.warehouseCanadaProvinceDiv.hide();
          elsPage.warehouseStateTextDiv.hide();
          if(warehouseLevelRmas){
            shipToAddress.empty().append(usOptions);   
          }
        } else if (elsPage.warehouseCountry.val() === 'CA') {
          elsPage.warehouseUsaStateDiv.hide();
          elsPage.warehouseCanadaProvinceDiv.show();
          elsPage.warehouseStateTextDiv.hide();
          if(warehouseLevelRmas) {
            shipToAddress.empty().append(canadaOptions);
          }
        } else {
          elsPage.warehouseUsaStateDiv.hide();
          elsPage.warehouseCanadaProvinceDiv.hide();
          elsPage.warehouseStateTextDiv.show();
          if(warehouseLevelRmas) {
            shipToAddress.empty().append(shipToAddressOptions);
          }
        }     
    }

    const initialCountryValue = $("#warehouse-country").val();
    if(initialCountryValue == "US") {
      elsPage.warehouseCountry.val(initialCountryValue).trigger("change");
    }
  }

  function handleCreditChange() {
    hideAllCreditInfo();

    switch ($(this).val()) {
      case "EC":
        elsPage.specialEarlyCreditMsg.show();
        break;
      case "DC":
        elsPage.specialNonCreditMsg.show();
        break;
      case "GO":
        elsPage.specialGiftCreditMsg.show();
        break;
      default:
        break;
    }
  }

  function hideAllCreditInfo() {
    elsPage.specialEarlyCreditMsg.hide();
    elsPage.specialNonCreditMsg.hide();
    elsPage.specialGiftCreditMsg.hide();
  }

  function displayMultiItemMsg() {
    if (elsPage.addRmaSearchItemDiv.find(".item-returning-loop-wrapper").length > 1) {
      elsPage.rmaMultiItemsWarning.show();
    } else {
      elsPage.rmaMultiItemsWarning.hide();
    }
  }


  //HB-11513 start
  function buildWarehouseProduct(dataObj, rmaItemCount) {

    let rmaItems = rmaData.rmaItemDetails;

    rmaItemCount = $(".warehouse-item-returning-loop-wrapper").length + 100;

     var    maxValue = rmaItemCount;
     $(".add-warehouse-rma-product-quantity").each(function(index, obj){
       var    qtyName = $(this).attr("name");
       var regExp = /\[.+\]/g;
       var matches = qtyName.match(regExp);
       var    qtyValue = parseInt(matches[0].replace("[", "").replace("]", ""));
       if (qtyValue >= maxValue){
         maxValue = qtyValue;
       }
     });

     rmaItemCount = maxValue + 1;

    let formObjName = "rmaItemDetails";
    let formIndexElement = formObjName+"["+rmaItemCount+"]";

    if (isBlank(dataObj.itmReturnable) || isFalsey(dataObj.itmReturnable)) {
      formObjName = "nonReturnableItemDetails";
    }

      let warehouseProductEl =  render(warehouseProductTemplate, {
      formIndexEle: formIndexElement,
      sku: dataObj.itmSku,
      upc: dataObj.itmUpc,
      model: dataObj.itmModel,
      skuHidden: dataObj.itmSku,
      rmdAmlStatus: dataObj.rmdAmlStatus,
      rmaFromCountry: dataObj.rmaFromCountry,
      rmaItemCount: rmaItemCount,
      showOrHide: "hide"
    });


    return warehouseProductEl;
  }
  //HB-11513 end
  function buildProduct(dataObj, rmaItemCount) {
    let formObjName = "rmaItemDetails";
    if (isBlank(dataObj.itmReturnable) || isFalsey(dataObj.itmReturnable)) {
      formObjName = "nonReturnableItemDetails";
    }
    const productEl = $(productTemplate);
    productEl.find(elementsPageMap.itemMarkedAsNonReturnableMsg).hide();

    evaluateOrderNumberConfiguration(oonVisible, oonMandatory, productEl);

    let sku = productEl.find(elementsPageMap.itmSku);
    sku.text(dataObj.itmSku);
    let upc = productEl.find(elementsPageMap.itmUpc);
    upc.text(dataObj.itmUpc);
    let description = productEl.find(elementsPageMap.itmDescription);
    description.text(dataObj.product.prdName);
    let brand = productEl.find(elementsPageMap.itmBrand);
    brand.text(dataObj.itmBrand);
    let model = productEl.find(elementsPageMap.itmModel);
    model.text(dataObj.itmModel);

    // painting product attributes on review page
    $(dataObj.itemsAttributes).each(function (i, v) {
      const procutAttrEl = $(productAttrTemplate);
      let attrName = procutAttrEl.find(elementsPageMap.addRmaItmAttrName);
      let attrValue = procutAttrEl.find(elementsPageMap.addRmaItmAttrValue);
      attrName.text(v.itaAttributeKey);
      attrValue.text(v.itaAttributeValue);
      let addRmaItmAttrEle = productEl.find(".add-rma-itm-attr");
      addRmaItmAttrEle.append(procutAttrEl);
    });

    let skuHidden = productEl.find(elementsPageMap.itmSkuHidden);
    skuHidden.val(dataObj.itmSku);
    skuHidden.attr('name', formObjName + "[" + rmaItemCount + "].itemSku");

    let addRmaProductQuantityVar = productEl.find(elementsPageMap.addRmaProductQuantity);
    addRmaProductQuantityVar.attr('name', formObjName + "[" + rmaItemCount + "].itemExpectedQty");
    let addRmaProductOrderNo = productEl.find(elementsPageMap.addRmaProductNo);
    addRmaProductOrderNo.attr('name', formObjName + "[" + rmaItemCount + "].rmdOrderNumber");

    showOrHideProductCaptures(productEl, captureReturnReason, elementsPageMap.addRmaReasonDiv, elementsPageMap.addRmaReason, formObjName, rmaItemCount, "returnReason");
    showOrHideProductCaptures(productEl, captureFinalSale, elementsPageMap.addRmaProductFinalSaleDiv, elementsPageMap.addRmaProductFinalSale, formObjName, rmaItemCount, "rmdFinalSaleItem");
    showOrHideProductCaptures(productEl, captureWeight, elementsPageMap.addRmaProductWeigntDiv, elementsPageMap.addRmaProductWeignt, formObjName, rmaItemCount, "rmdWeight");
    showOrHideProductCaptures(productEl, captureProductNotes, elementsPageMap.addRmaNotesDiv, elementsPageMap.addRmaNotes, formObjName, rmaItemCount, "rmdNotes");

    if (isTruthy(captureReturnReason)) {
      let selectEl = productEl.find(elementsPageMap.itmSelectBlock);
      selectEl.select2({ data: getReturnReasonData(dataObj.returnResons) });
    }
    if (isBlank(dataObj.itmReturnable) || isFalsey(dataObj.itmReturnable)) {
      productEl.find(elementsPageMap.itemMarkedAsNonReturnableMsg).show();
    }
    return productEl;
  }

  function showOrHideProductCaptures(productEl, showCapture, divClassName, inputElementClassName, formObjName, rmaItemCount, propertyName) {
    if (isTruthy(showCapture)) {
      let addRmaCaptureVar = productEl.find(inputElementClassName);
      addRmaCaptureVar.attr('name', formObjName + "[" + rmaItemCount + "]." + propertyName);
    } else {
      productEl.find(divClassName).hide();
    }
  }

  function appendProductAttr(itemsAttributes) {
    itemsAttributes.each(function (i, v) {
      const procutAttrEl = $(productAttrTemplate);
      let attrName = procutAttrEl.find(elementsPageMap.addRmaItmAttrName);
      let attrValue = procutAttrEl.find(elementsPageMap.addRmaItmAttrValue);
      attrName.text(v.itaAttributeKey);
      attrValue.text(v.itaAttributeValue);
      let addRmaItmAttrEle = productEl.find(".add-rma-itm-attr");
      addRmaItmAttrEle.append(procutAttrEl);
    });
  }

  function getReturnReasonData(returnReasonDataObj) {
    var returnReasonArray = [];
    $(returnReasonDataObj).each(function (i, v) {
      var row = {};
      row.id = v.cdmValue;
      row.text = v.cdmMeaning;
      returnReasonArray.push(row);
    });
    return returnReasonArray;
  }


  var searchItem = function (searchedValue, addSkuCalledFromModal) {
    var itemSkuOnPage = [];
    elsPage.addRmaSearchItemDiv.find(".itmSku").each(function (i, v) { itemSkuOnPage.push($(v).text()) });
    var itemSkuInput = searchedValue;
    itemSkuGlobal = searchedValue;
    if (itemSkuOnPage.indexOf(itemSkuInput) == -1 || addSkuCalledFromModal) {
      $.ajax({
        url: elsPage.addProductBtn.data('url'),
        type: 'POST',
        dataType: 'json',
        data: {
          itmSkuOrUpc: itemSkuInput,
          returnFromState: elsPage.returnFromState.val()
        },
        beforeSend: function () {
          $.blockUI({ message: 'Please Wait...' });
        },
        complete: function () {
          $.unblockUI();
        },
        success: function (resp) {
          if (resp.data && resp.data != null && resp.data != 'null') {
            if (resp.data.length === 1) {
              let item = resp.data[0];
              let itemSkuOnPage = [];
              elsPage.addRmaSearchItemDiv.find(".itmSku").each(function (i, v) { itemSkuOnPage.push($(v).text()) });
              if (itemSkuOnPage.indexOf(item.itmSku) === -1 || addSkuCalledFromModal) {
                elsPage.addRmaSearchItemDiv.append(buildProduct(item, rmaItemCount));
                rmaItemCount = rmaItemCount + 1;
                elsPage.itmSkuOrUpc.val('');
                fillDynamicContentToWizard();
                // displayMultiItemMsg();
              } else {
                displayDuplicateSkuModal();
                // comment below error and open modal for duplicate sku
                // elsPage.itemSkuAlreadyAdded.show();
              }
            } else {
              AddRmaObj.displayUpcModal(resp.data);
              elsPage.itmSkuOrUpc.val('');
            }
          } else if (resp.data == null || resp.data == 'null') {
            AddRmaObj.manualRmaItemSrchNull();
          } else {
            alert("Error in getting Item details");
          }
        },
        error: function (xhr, status, error) {
          alert("Error in getting Item details");
        }
      });
    } else {
      displayDuplicateSkuModal(); // comment below error and open modal for duplicate sku
      // elsPage.itemSkuAlreadyAdded.show();
    }
  };

  var searchWarehouseItem = function (searchedValue, addSkuCalledFromModal) {
    let itemSkuOnPage = [];
    elsPage.addWarehouseRmaSearchItemDiv.find(".warehouseitmSku").each(function (i, v) { itemSkuOnPage.push($(v).text()) });
    let itemSkuInput = searchedValue;
    itemSkuGlobal = searchedValue;
    if (itemSkuOnPage.indexOf(itemSkuInput) == -1 || addSkuCalledFromModal) {
      $.ajax({
        url: elsPage.addWarehouseProductBtn.data('url'),
        type: 'POST',
        dataType: 'json',
        data: {
          itmSkuOrUpc: itemSkuInput,
          returnFromState: elsPage.returnFromState.val()
        },
        beforeSend: function () {
          $.blockUI({ message: 'Please Wait...' });
        },
        complete: function () {
          $.unblockUI();
        },
        success: function (resp) {
          if (resp.data && resp.data != null && resp.data != 'null') {
            if (resp.data.length === 1) {
              let item = resp.data[0];
              let itemSkuOnPage = [];
              elsPage.addWarehouseRmaSearchItemDiv.find(".warehouseitmSku").each(function (i, v) { itemSkuOnPage.push($(v).text()) });
              if (itemSkuOnPage.indexOf(item.warehouseitmSku) === -1 || addSkuCalledFromModal) {
                elsPage.addWarehouseRmaSearchItemDiv.append(buildWarehouseProduct(item, rmaItemCount));
                rmaItemCount = rmaItemCount + 1;
                elsPage.itmSkuOrUpc.val('');
                fillDynamicContentToWizard();
                // displayMultiItemMsg();
              } else {
                displayDuplicateSkuModal();
                // comment below error and open modal for duplicate sku
                // elsPage.itemSkuAlreadyAdded.show();
              }
            } else {
              AddRmaObj.displayUpcModal(resp.data);
              elsPage.itmSkuOrUpc.val('');
            }
          } else if (resp.data == null || resp.data == 'null') {
            AddRmaObj.manualRmaItemSrchNull();
          } else {
            alert("Error in getting Item details");
          }
        },
        error: function (xhr, status, error) {
          alert("Error in getting Item details");
        }
      });
    } else {
      displayDuplicateSkuModal(); // comment below error and open modal for duplicate sku
      // elsPage.itemSkuAlreadyAdded.show();
    }
  };


  function fillDynamicContentToWizard() {
    const rmaSelectedLevel = elsPage.rmaLevel.val();
    if (rmaSelectedLevel == 'warehouse') {
      let containerForItemsRevPg = $('.review-warehouse-rma-item-outer');
      containerForItemsRevPg.children().remove();
      let content = [];
      $.each($(".warehouse-item-returning-loop-wrapper"), function (i, v) {
        content.push({
          revWhsRmaProdSku: $(v).find(".warehouseitmSku").text(),
          revWhsRmaUpc: $(v).find(".warehouseitmUpc").text(),
          revWhsRmaDesc: $(v).find(".warehouseitmModel").text(),
          revWhsRmaQty: $(v).find(".add-warehouse-rma-product-quantity").val(),
          revWhsRmaRtv: $(v).find("#warehouseRTV").val()
        });
      });
      const reviewProdElArray = _(content).map(buildWarehouseReviewProduct);
      containerForItemsRevPg.append(reviewProdElArray);

    } else {
      var containerForItemsRevPg = $('.review-rma-item-outer');
      containerForItemsRevPg.children().remove();
      var content = [];
      $.each($(".item-returning-loop-wrapper"), function (i, v) {
        content.push({
          itmSku: $(v).find(".itmSku").text(),
          itmUpc: $(v).find(".itmUpc").text(),
          itmDescription: $(v).find(".itmDescription").text(),
          itmAttr: $(v).find(".add-rma-itm-attr"),

          addRmaProductQty: $(v).find(".add-rma-product-quantity").val(),
          addRmaReason: $(v).find(".add-rma-reason option:selected").text(),
          addRmaOrderNumber: $(v).find(".add-rma-order-number").val(),
          addRmaFinalSale: $(v).find(".add-rma-product-final-sale").is(':checked'),
          addRmaProductWeight: $(v).find(".add-rma-product-weight").val(),
          addRmaNotes: $(v).find(".add-rma-notes").val()
        });
      });
      const reviewProdElArray = _(content).map(buildReviewProduct);
      containerForItemsRevPg.append(reviewProdElArray);

      displayMultiItemMsg();
    }
  }

  function buildWarehouseReviewProduct(dataObj) {
      const warehouseReviewProductEl =
       render(reviewWarehouseProductTemplate, {
      sku: dataObj.revWhsRmaProdSku,
      upc: dataObj.revWhsRmaUpc,
      desc: dataObj.revWhsRmaDesc,
      qty: dataObj.revWhsRmaQty,
      rtv: dataObj.revWhsRmaRtv
    });

    return warehouseReviewProductEl;
  };

  function buildReviewProduct(dataObj) {
    const reviewProductEl = $(reviewProductTemplate);
    let sku = reviewProductEl.find(elementsPageMap.revRmaProdSku);
    sku.text(dataObj.itmSku);
    let upc = reviewProductEl.find(elementsPageMap.revRmaUpc);
    upc.text(dataObj.itmUpc);
    let desc = reviewProductEl.find(elementsPageMap.revRmaDesc);
    desc.text(dataObj.itmDescription);

    let reviewRmaItmAttrVar = reviewProductEl.find(elementsPageMap.reviewRmaItmAttr);
    $.each((dataObj.itmAttr).find(".add-rma-itm-attr-div"), function (i, v) {
      const procutAttrEl = $(productAttrTemplate);
      let attrName = procutAttrEl.find(elementsPageMap.addRmaItmAttrName);
      let attrValue = procutAttrEl.find(elementsPageMap.addRmaItmAttrValue);
      attrName.text($(v).find(".add-rma-itm-attr-name").text());
      attrValue.text($(v).find(".add-rma-itm-attr-value").text());
      reviewRmaItmAttrVar.append(procutAttrEl);
      if (defaultItemConfig) {
        $(".add-rma-itm-attr-dropdown").hide();
      }
    });

    // Add add rma product attr - Final Sale to review page
    addMoreProductAttrToReviewTab(captureFinalSale, reviewRmaItmAttrVar, 'Final Sale:', dataObj.addRmaFinalSale, true);
    // Add add rma product attr - Original Order Number to review page
    addMoreProductAttrToReviewTab(oonVisible, reviewRmaItmAttrVar, 'Original Order Number:', dataObj.addRmaOrderNumber, false);
    // Add add rma product attr - Vendor Authorization Number to review page
    // addMoreProductAttrToReviewTab(reviewRmaItmAttrVar, 'Vendor Authorization Number:', dataObj.addRmaOrderNumber, false);
    addMoreProductAttrToReviewTab(captureReturnReason, reviewRmaItmAttrVar, 'Reason For Return:', dataObj.addRmaReason, false);
    addMoreProductAttrToReviewTab(captureWeight, reviewRmaItmAttrVar, 'Weight:', dataObj.addRmaProductWeight, false);
    let notes = reviewProductEl.find(elementsPageMap.reviewRmaNotes);
    if (isTruthy(captureProductNotes)) {
      let notesVal = notes.find(elementsPageMap.addRmaItmAttrValue);
      notesVal.text(dataObj.addRmaNotes);
    } else {
      notes.hide();
    }

    let qty = reviewProductEl.find(elementsPageMap.revRmaQty);
    qty.text(dataObj.addRmaProductQty);
    return reviewProductEl;
  };

  function verify(selectedValue) {
    if (selectedValue == "") {
      return;
    } else {
      searchItem(selectedValue, false);
    }
  };
  function verifyWarehouse(selectedValue) {
    if (selectedValue == "") {
      return;
    } else {
      searchWarehouseItem(selectedValue, false);
    }
  };



  const select2AjaxDefaults = {
    dataType: 'json',
    delay: 250,
    processResults: function (data, params) {

      params.page = params.page || 1;
      return {
        results: data,
        pagination: {
          more: (params.page * 20) < data.total_count
        }
      };
    },
    cache: true
  };



  function configureDataCallback({ paramKey }) {

    return function (params) {
      return {
        [paramKey]: params.term,
        customerId : $("#find-rma-by-address-or-location").val(),
        rmaLevel :  elsPage.rmaLevel.val()
      };
    };
  }

  // Add some(Final Sale, Order No, Vendor Auth No) product attributes to review page
  function addMoreProductAttrToReviewTab(showCapture, reviewRmaItmAttrVar, prdAttrName, prdAttrValue, isBooleanAttrVal) {
    if (isTruthy(showCapture)) {
      const procutAttrEl = $(productAttrTemplate);
      let attrName = procutAttrEl.find(elementsPageMap.addRmaItmAttrName);
      let attrValue = procutAttrEl.find(elementsPageMap.addRmaItmAttrValue);
      attrName.text(prdAttrName);
      if (isBooleanAttrVal) {
        if (prdAttrValue == true) {
          attrValue.text('Yes');
        } else {
          attrValue.text('No');
        }
      } else {
        attrValue.text(prdAttrValue);
      }
      reviewRmaItmAttrVar.append(procutAttrEl);
    }
  }

  function evaluateOrderNumberConfiguration(visible, mandatory, productEl) {

    productEl.find(elementsPageMap.addRmaOrderNumber).on("input", function(e){
      $(this).next(".error").remove();
     });

    if (visible) {
      productEl.find(elementsPageMap.originalOrderNumberDiv).show();
      productEl.find(elementsPageMap.addRmaOrderNumber).prop('required', false);
    } else {
      productEl.find(elementsPageMap.originalOrderNumberDiv).hide();
    }

    if (mandatory) {
      productEl.find(elementsPageMap.addRmaOrderNumber).prop('required', true);
      productEl.find(elementsPageMap.originalOrderNumberLabelRequired).show();
      productEl.find(elementsPageMap.originalOrderNumberLabelNotRequired).hide();
    } else {
      productEl.find(elementsPageMap.addRmaOrderNumber).prop('required', false);
      productEl.find(elementsPageMap.originalOrderNumberLabelRequired).hide();
      productEl.find(elementsPageMap.originalOrderNumberLabelNotRequired).show();
    }
  }

  function renderDuplicateSkuModal() {
    duplicateSkuModal = $(render(
      modalHtml,
      {
        modalDialogClass: 'q-modal-dialog-500',
        title: 'Duplicate SKU Added',
        leftAlignTitle: true,
        body: duplicateSkuTemplate,
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: '<a href="#" class="base-btn purple-btn v2-btn duplicate-sku-add-button">Add as Additional SKU</a> <a href="#" class="base-btn purple-btn duplicate-sku-close-modal">Do Not Add SKU</a>'
      }
    ));
    elsPage.addRmaParent.append(duplicateSkuModal);
  }

  function displayDuplicateSkuModal() {
    duplicateSkuModal.modal("show");
  }
  function hideDuplicateSkuModal() {
    duplicateSkuModal.modal("hide");
  }
  function addDuplicateSkuFromModal() {
    // add item with duplicate sku
    const rmaSelectedLevel = elsPage.rmaLevel.val();
    duplicateSkuModal.modal("hide");
    if (rmaSelectedLevel == 'warehouse' || rmaSelectedLevel == 'customer') {
      searchWarehouseItem(itemSkuGlobal, true);
    }
    else {
      searchItem(itemSkuGlobal, true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/returnRequestsWizard/returnRequestsWizardLogic.js